import React from "react";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import AvpHeader from "../shared/header/AvpHeader";
import BreadCrumb from "../shared/header/BreadCrumb";
import { DataGrid } from "@mui/x-data-grid";
import {
  userIsLogged,
  getRoute,
  apiGetAnaGruppoUtenteIndex,
  apiDeleteAnaGruppoUtente,
  apiPostAnaGruppoUtente,
} from "../shared/manager/api_manager";
import { useEffectOnce } from "../shared/manager/use_effect_once";
import Alert from "@mui/material/Alert";
import Collapse from "@mui/material/Collapse";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useLingueStore } from "../sistema/storeLingua";

export default function GestioneGruppiUtenteScreen() {
  const navigate = useNavigate();

  const [utentiStatus, setUtentiStatus] = useState(0);
  const [rows, setRows] = useState([]);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [idToDelete, setIdToDelete] = useState(null);
  const [alertSuccessOpen, setAlertSuccessOpen] = useState(false);
  const [alertErrorOpen, setAlertErrorOpen] = useState(false);
  const { selectedLinguaTesto } = useLingueStore((state) => state);
  const breadCrumb = [
    {
      title: selectedLinguaTesto?.GestioneGruppiUtenteBreadcrumb1,
      link: "/utenti",
    },
    { title: selectedLinguaTesto?.GestioneGruppiUtenteBreadcrumb2, link: null },
  ];

  useEffectOnce(() => {
    startPage();

    return () => stopPage();
  });

  useEffect(() => {
    initPage();
  }, [utentiStatus]);

  function startPage() {
    console.log("startPage");

    if (userIsLogged() == false) {
      navigate("/login");
    } else {
      var route = getRoute();
      if (!route.funzioni.some((g) => g.idFunzione === 10)) {
        navigate("/");
      }
      initPage();
    }
  }

  function initPage() {
    console.log("initPage");

    apiGetAnaGruppoUtenteIndex(utentiStatus, function (response) {
      if (response != null && response.status >= 200 && response.status < 400) {
        setRows(response.data);
      } else {
        setRows([]);
      }
    });
  }

  function stopPage() {
    console.log("stopPage");
  }

  const columns = [
    {
      field: "status",
      headerName: "",
      width: 20,
      headerClassName: "tableHeader",
      renderCell: (params) => {
        return params.row.sysAttivo ? (
          <div className="tableStatusActive"></div>
        ) : (
          <div className="tableStatusInactive"></div>
        );
      },
    },
    //{ field: 'idGruppoUtente', headerName: 'ID', flex: 1, headerClassName: 'tableHeader' },
    {
      field: "descrizioneGruppo",
      headerName: selectedLinguaTesto?.GestioneGruppiUtenteColumnDesc,
      flex: 2,
      headerClassName: "tableHeader",
    },
    {
      field: "idFatturazione",
      headerName: selectedLinguaTesto?.GestioneGruppiUtenteColumnBillingTo,
      flex: 2,
      headerClassName: "tableHeader",
    },
    {
      field: "rifAmmNomeCognome",
      headerName: selectedLinguaTesto?.GestioneGruppiUtenteColumnRifAmm,
      flex: 2,
      headerClassName: "tableHeader",
    },
    {
      field: "rifAmmEmail",
      headerName: selectedLinguaTesto?.GestioneGruppiUtenteColumnRifAmmMail,
      flex: 2,
      headerClassName: "tableHeader",
    },
    {
      field: "rifAmmTelefono",
      headerName: selectedLinguaTesto?.GestioneGruppiUtenteColumnRifAmmTel,
      flex: 2,
      headerClassName: "tableHeader",
    },
    {
      field: "action",
      headerName: "",
      flex: 2,
      sortable: false,
      headerClassName: "tableHeader",
      align: "right",
      renderCell: (params) => {
        const onClick = (event) => {
          event.stopPropagation(); // don't select this row after clicking

          console.log(params.row);
          const action = event.target.dataset.action;
          if (action == "edit") {
            handleEdit(params.row.idGruppoUtente);
          } else if (action == "delete") {
            handleDelete(params.row.idGruppoUtente);
          } else if (action == "restore") {
            handleRestore(params.row.idGruppoUtente);
          }
        };

        return (
          <div className="tableActionButton">
            <img
              data-action="edit"
              src="/images/edit_btn.svg"
              title={selectedLinguaTesto?.GestioneGruppiUtenteImgEdit}
              onClick={onClick}
            />
            <img
              data-action="delete"
              data-rowid=""
              src="/images/delete_btn.svg"
              title={selectedLinguaTesto?.GestioneGruppiUtenteImgDelete}
              onClick={onClick}
              style={{ display: params.row.sysAttivo ? "inline" : "none" }}
            />
            <img
              data-action="restore"
              data-rowid=""
              src="/images/restore_user.svg"
              title={selectedLinguaTesto?.GestioneGruppiUtenteImgRestore}
              onClick={onClick}
              style={{ display: params.row.sysAttivo ? "none" : "inline" }}
            />
          </div>
        );
      },
    },
  ];

  function handleNew() {
    const dest = "/utenti/gruppi/-1";
    navigate(dest);
  }

  function handleEdit(idGruppoUtente) {
    const dest = "/utenti/gruppi/" + idGruppoUtente;
    navigate(dest);
  }

  function handleDelete(idGruppoUtente) {
    setIdToDelete(idGruppoUtente);
    setDeleteDialogOpen(true);
  }

  function handleRestore(idGruppoUtente) {
    let group = null;
    if (rows != null && rows.length > 0) {
      for (var i = 0; i < rows.length; i++) {
        if (rows[i].idGruppoUtente == idGruppoUtente) {
          group = rows[i];
          break;
        }
      }
    }

    if (group != null) {
      group.sysAttivo = true;
      apiPostAnaGruppoUtente(group, function (response) {
        if (
          response != null &&
          response.status >= 200 &&
          response.status < 400
        ) {
          setAlertSuccessOpen(true);
          setAlertErrorOpen(false);
          initPage();
        } else {
          setAlertSuccessOpen(false);
          setAlertErrorOpen(true);
        }
      });
    }
  }

  const handleDeleteDialogClose = () => {
    setDeleteDialogOpen(false);
  };

  const handleDeleteDialogConfirm = () => {
    setDeleteDialogOpen(false);

    apiDeleteAnaGruppoUtente(idToDelete, function (response) {
      if (response != null && response.status >= 200 && response.status < 400) {
        setAlertSuccessOpen(true);
        setAlertErrorOpen(false);
        initPage();
      } else {
        setAlertSuccessOpen(false);
        setAlertErrorOpen(true);
      }
    });
  };

  function onUtentiStatusChange(event) {
    let value = event.target.value;
    setUtentiStatus(value);
  }

  function handleUtentiTab() {
    const dest = "/utenti";
    navigate(dest);
  }

  return (
    <div id="avp-gestioneavp-screen">
      <AvpHeader selectedMenuId={"utenti"} />
      <BreadCrumb items={breadCrumb} helpLink={"help.html#gruppiutenti"} />
      <div id="avp-cms-screen-container">
        <Collapse
          in={alertSuccessOpen}
          timeout={{ enter: 1000, exit: 1000 }}
          addEndListener={() => {
            setTimeout(() => {
              setAlertSuccessOpen(false);
            }, 2000);
          }}
        >
          <Alert
            variant="filled"
            severity="success"
            onClose={() => {
              setAlertSuccessOpen(false);
            }}
          >
            {selectedLinguaTesto?.GestioneGruppiUtenteAlertSuccess}
          </Alert>
        </Collapse>
        <Collapse in={alertErrorOpen}>
          <Alert
            variant="filled"
            severity="error"
            onClose={() => {
              setAlertErrorOpen(false);
            }}
          >
            {selectedLinguaTesto?.GestioneGruppiUtenteAlertError}
          </Alert>
        </Collapse>

        <div className="avp-cms-tab clearfix">
          <div className={"avp-cms-tab-item"} onClick={handleUtentiTab}>
            {selectedLinguaTesto?.GestioneGruppiUtenteUserTab}
          </div>
          <div className={"avp-cms-tab-item avp-cms-tab-item-selected"}>
            {selectedLinguaTesto?.GestioneGruppiUtenteGroupTab}
          </div>
        </div>

        <div className="avp-cms-screen-title">{selectedLinguaTesto?.GestioneGruppiUtenteTitle}</div>
        <div className="avp-cms-screen-content">
          <div className="avp-cms-screen-toolbar clearfix">
            <div className="avp-cms-screen-toolbar-title">
              {rows.length}&nbsp;{selectedLinguaTesto?.GestioneGruppiUtenteSubTitle}
            </div>
            <div className="avp-cms-screen-toolbar-filters"></div>
            <div className="avp-cms-screen-toolbar-add" onClick={handleNew}>
              <button>{selectedLinguaTesto?.GestioneGruppiUtenteButtonNew}</button>
            </div>
          </div>

          <div className="avp-cms-screen-content-row clearfix">
            <div className="avp-cms-screen-content-column">
              <label htmlFor="avp-form-tipofile">{selectedLinguaTesto?.GestioneGruppiUtenteState}</label>
              <br />
              <select
                id="avp-form-tipofile"
                value={utentiStatus}
                onChange={onUtentiStatusChange}
              >
                <option key={0} value="0">
                  {selectedLinguaTesto?.GestioneGruppiUtenteOptionActive}
                </option>
                <option key={1} value="1">
                  {selectedLinguaTesto?.GestioneGruppiUtenteOptionNotActive}
                </option>
              </select>
            </div>
          </div>

          <DataGrid
            disableColumnMenu
            getRowId={(row) => row.idGruppoUtente}
            rows={rows}
            columns={columns}
            getRowClassName={(params) => "tableRow"}
            initialState={{
              pagination: {
                paginationModel: {
                  pageSize: 20,
                },
              },
            }}
            pageSizeOptions={[20, 30, 50]}
            disableRowSelectionOnClick
          />
        </div>
      </div>

      <Dialog
        open={deleteDialogOpen}
        onClose={handleDeleteDialogClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {selectedLinguaTesto?.GestioneGruppiUtenteDialogTitle}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {selectedLinguaTesto?.GestioneGruppiUtenteDialogText}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleDeleteDialogClose}>{selectedLinguaTesto?.GestioneGruppiUtenteDialogUndo}</Button>
          <Button onClick={handleDeleteDialogConfirm} autoFocus>
            {selectedLinguaTesto?.GestioneGruppiUtenteDialogConfirm}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
